import { useCallback } from "react";

import { usePreferences } from "@/core/state/preferences";

import { translate } from "./lookup";
import type { MessageKey } from "./types";

export function useT() {
  const locale = usePreferences((state) => state.locale);
  return useCallback((key: MessageKey, vars?: Record<string, string | number>) => translate(locale, key, vars), [locale]);
}
